import { MenuItem } from '@material-ui/core';
import styled from 'styled-components';
import { FixedSizeList as List } from 'react-window';
import Text from 'components/base/Text';

export const StyledMenuItemWrapper = styled.div`
  padding: 6.5px 0;
  display: flex;
  justify-content: center;
`;

export const StyledMenuItem = styled(MenuItem).withConfig({
  shouldForwardProp: prop => prop !== 'borderBottom'
})`
  ${({ cursor }) => `cursor: ${cursor} !important;`}
  ${({ borderBottom }) =>
    borderBottom ? `border-bottom: 1px solid #bdc1c6 !important;` : ''}
  
  height: 95% !important;
  margin: auto !important;
  justify-content: space-between !important;

  svg.hidden {
    display: none;
  }

  :hover {
    svg.hidden {
      display: block;
    }
  }

  ${Text} {
    align-self: center;
    margin: 0;
    padding: 0;
  }
`;

export const StyledList = styled(List)`
  overflow-x: hidden;
`;
